import { RootState } from 'store';
import { useSelector } from 'react-redux';

import { DRIVERS_STATE } from '../../constants';

export const useDriverFuelAssignmentsCards = () => {
  const driverFuelAssignmentsCards = useSelector((state: RootState) => state[DRIVERS_STATE].fuelAssignmentsCards.data);
  return driverFuelAssignmentsCards;
};